import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logStartAudioTestCall() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.StartAudioTest,
    actionScenarioType: ScenarioType.AudioTest,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.Enable,
    moduleName: ModuleName.StartAudioTestButton,
    moduleSummary: ModuleSummary.StartAudioTestButton,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}

export function logCancelAudioTestCall() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.CancelAudioTest,
    actionScenarioType: ScenarioType.AudioTest,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.Enable,
    moduleName: ModuleName.CancelAudioTestButton,
    moduleSummary: ModuleSummary.CancelAudioTestButton,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}

export function logCompletedAudioTest() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.CompletedAudioTest,
    actionScenarioType: ScenarioType.AudioTest,
    actionGesture: ActionGesture.None,
    actionOutcome: PanelActionOutcome.None,
    moduleName: ModuleName.AudioTestCall,
    moduleSummary: ModuleSummary.CompletedAudioTestCall,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.Direct,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}

export function logAudioTestCallTimeout() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.AudioTestCallTimeout,
    actionScenarioType: ScenarioType.AudioTest,
    actionGesture: ActionGesture.None,
    actionOutcome: PanelActionOutcome.None,
    moduleName: ModuleName.AudioTestCallTimeoutPage,
    moduleSummary: ModuleSummary.AudioTestCallTimeoutPage,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.Direct,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
